import { Pipe } from '@angular/core';
var ShufflePipe = (function () {
    function ShufflePipe() {
    }
    // Using a version of the Fisher-Yates shuffle algorithm
    // https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
    ShufflePipe.prototype.transform = function (input) {
        if (!Array.isArray(input)) {
            return input;
        }
        var shuffled = input.slice();
        for (var i = 0, n = input.length - 1, l = n; i < l; ++i) {
            var j = Math.floor(Math.random() * (n - i + 1)) + i;
            _a = [shuffled[j], shuffled[i]], shuffled[i] = _a[0], shuffled[j] = _a[1];
        }
        return shuffled;
        var _a;
    };
    return ShufflePipe;
}());
export { ShufflePipe };
ShufflePipe.decorators = [
    { type: Pipe, args: [{ name: 'shuffle' },] },
];
/** @nocollapse */
ShufflePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=shuffle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/shuffle.js
// module id = 210
// module chunks = 4